import React from 'react';
import { Handle, Position } from 'reactflow';
import Icon from '../../../components/forms/icon.component';
import { NodeData } from '../../../pages/campaings/flows/types';

interface Props {
  data: NodeData;
}
const InteractiveBody: React.FC<Props> = ({ data }) => {
  if (!data.interactive) return <div>No se encontró información</div>;
  const it: any = data.interactive;

  if (it.type === 'TEXT') {
    const texto = it.text?.es ?? '';
    return <p className="nowrap-lines-2 node-width-fit pe-2">{texto}</p>;
  }

  // Para LIST y BUTTONS
  const block = it.type === 'LIST' ? it.list : it.buttons;

  if (!block) return <div>No se encontró contenido interactivo</div>;

  return (
    <>
      {/* Header, image, body */}
      {block.header?.es && <h6 className="node-title2 my-1 fs-8">{block.header.es}</h6>}
      {block.image?.es && (
        <div className="node-image-container mt-2 me-2">
          <img src={block.image.es} alt="preview" className="interactive-image" />
        </div>
      )}
      <p className="nowrap-lines-1 node-width-fit pe-2 mb-1 fs-7">{block.body.es}</p>
      {block.footer && (
        <p className="nowrap-lines-1 node-width-fit pe-2 mb-2">
          <i>{block.footer.es}</i>
        </p>
      )}
      <h6 className="node-title2 mt-1 mb-2 fs-8">Opciones</h6>

      <ul className="chatbot-node-outputs">
        {block.action.sections.rows.map((row: any, i: number) => {
          const label = row.es || row.text?.es;
          return (
            <li key={i} className="nowrap-lines-1 position-relative d-flex align-items-center mb-2">
              <span className="me-1 d-flex align-items-center">
                {row.type === 'URL' ? (
                  <Icon icon="ki-fasten" size="fs-4" />
                ) : (
                  <Icon icon="ki-password-check" size="fs-4" />
                )}
              </span>
              <span className="mw-100px overflow-hidden text-truncate">{label}</span>
              <Handle
                type="source"
                position={Position.Right}
                id={label}
                className="handle-connector internal"
              />
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default React.memo(InteractiveBody);
